import axios from 'axios';

export const getCountry  = () => {
  const url = 'https://www.iplocate.io/api/';
  const data = axios.create({
    baseURL: url,
  });
  return data.get(`lookup/?apikey=${process.env.VUE_APP_IP_KEY}`);
};